import { ApiService } from "../..";

export const createGroup = (data: { name: string; description: string }) => {
  return ApiService.baseAction(
    "group/create",
    {
      data,
    },
    "post"
  );
};
